





import Vue from 'vue'
import {MSGRS} from './msgrsList.vue'
import User from '@/models/Users/User'
export default Vue.extend({
  props: {
    msgr: String,
    scope: {} as () => User
  },
  methods: {
    async disableMsgr (): Promise<void> {
      try {
        // @ts-ignore
        await this.$confirm(`${this.$t('students.messenger.really_want_disable')} ${this.getMsgrLabel()}`, this.$t('labels.attention'), {
          confirmButtonText: 'OK',
          cancelButtonText: this.$t('labels.cancel'),
          type: 'warning'
        })
        await this.$store.dispatch('users/msgrUnbind', {user_id: this.scope.getId(), msgr: this.msgr})
        await this.$store.dispatch('users/loadUser', this.scope.getId())
        await this.$store.dispatch('user/loadUser')
        this.$message({
          message: `${this.$t('students.messenger.messenger')} ${this.getMsgrLabel()} ${this.$t('students.messenger.disable2')}`,
          type: 'success'
        });
      } catch (error) {
        console.log('LOG: disableMsgr', error)
        if (error.type) {
          // @ts-ignore
          this.$message.error(this.$t('students.messenger.can_not_disable'));
        }
      }
    },
    getMsgrLabel () {
      return MSGRS[this.msgr].label;
    }
  }
})
